namespace nscs.gameplay {

    export class Factory {
        private static ANIM:object = {
            'chickette_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'squat':{'start': 18, 'end':18},
                'pounceLand':{'start': 19, 'end':35},
                'pounce':{'start': 36, 'end':66},
                'climbing':{'start': 67, 'end':83},
                'grow':{'start': 84, 'end':115}
            },
            'chickette_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            },
            'nugget_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':59},
                'climbing':{'start': 60, 'end':76},
                'grow':{'start': 77, 'end':108}
            },
            'nugget_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            },
            'pam_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':64},
                'climbing':{'start': 65, 'end':81},
                'grow':{'start': 82, 'end':113}
            },
            'pam_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            }
        };

        scene:Phaser.Scene;
        constructor(scene:Phaser.Scene) {
            this.scene = scene;
            this.createAnimations();
        }

        private createAnimations():void {
            for (let k in Factory.ANIM) {
                let textureAtlas:string = 'objects-atlas';

                let data = Factory.ANIM[k];
                for (let animKey in data) {
                    let anim:string = Factory.createAnimName(animKey, k);
                    if (!this.scene.anims.exists(anim)) {
                        let animData = data[animKey];
                        let frames;
                        let genFrm = (_data)=>{
                            return this.scene.anims.generateFrameNames(textureAtlas, {
                                start: _data['start'], end: _data['end'], zeroPad: 4,
                                prefix: k, suffix: ''
                            });
                        };
                        if (animData.hasOwnProperty("length")) {
                            frames = [];
                            for (let ad of animData) {
                                let _frames = genFrm(ad);
                                frames = frames.concat(_frames);
                            }
                        } else {
                            frames = genFrm(animData);
                        }
                        this.scene.anims.create({
                            key: anim,
                            frames: frames,
                            frameRate: 60
                        });
                    }
                }
            }
        }

        public static createAnimName(animKey:string, frameName:string):string {
            return animKey + "_" + frameName;
        }

        private createDecorSprite(libId:string):Phaser.GameObjects.Sprite {
            let mapOrigins:object = {
                'decor2MC':{'x':53/83, 'y':85/85},
                'decor3MC':{'x':112/224, 'y':174/176},
                'decor24MC':{'x':39.5/81, 'y':83/83},
                'decor1MC':{'x':68/93, 'y':72/72},
                'decor12MC':{'x':56/79, 'y':69/63},
                'decor18MC':{'x':8/58, 'y':7/79},
                'decor16MC':{'x':56/79, 'y':69/63},
                'decor19MC':{'x':49/58, 'y':7/79},
                'decor17MC':{'x':56/79, 'y':10/58},
                'decor14MC':{'x':8/58, 'y':7/79},
                'decor15MC':{'x':56/79, 'y':10/58},
                'decor44MC':{'x':49/98, 'y':0.87},
                'decor11MC':{'x':16/32, 'y':32/32},
                'decor27MC':{'x':16/32, 'y':32/32},
                'decor6MC':{'x':56/112, 'y':72/74},
                'decor10MC':{'x':48/96, 'y':54/54},
                'decor26MC':{'x':48/96, 'y':54/54},
                'decor60MC':{'x':16/96, 'y':32/64},
                'decor61MC':{'x':16/96, 'y':32/64},
                'decor13MC':{'x':50/58, 'y':7/79},
                'decor47MC':{'x':1, 'y':1},
                'decor4MC':{'x':70/115, 'y':240/241},
                'decor21MC':{'x':56/113, 'y':164/164},
                'decor23MC':{'x':56/113, 'y':164/164},
                'decor46MC':{'x':0/37, 'y':60/89},
                'decor22MC':{'x':40/81, 'y':40/40},
                'decor31MC':{'x':23/46, 'y':21/25},
                'decor32MC':{'x':23/46, 'y':21/25},
                'decor45MC':{'x':23/46, 'y':21/25},
                'decor9MC':{'x':33/34, 'y':47/47},
                'decor8MC':{'x':33/34, 'y':47/47},
                'decor25MC':{'x':42/88, 'y':42/42},
                'decor58MC':{'x':53/83, 'y':85/86},
                'decor7MC':{'x':96/186, 'y':70/72},
                'decor5MC':{'x':174/348, 'y':315/315},
                'decor20MC':{'x':54/76, 'y':38/76},
                'decor38MC':{'x':10/53, 'y':40/53},
                'decor41MC':{'x':10/53, 'y':53/53},
                'decor57MC':{'x':47/95, 'y':48/49},
                'decor53MC':{'x':40/81, 'y':35/35},
                'decor50MC':{'x':37/81, 'y':31/33},
                'decor52MC':{'x':40/81, 'y':35/36},
                'decor51MC':{'x':40/81, 'y':35/37},
                'decor48MC':{'x':37/81, 'y':31/33},
                'decor49MC':{'x':37/84, 'y':31/33},
                'decor36MC':{'x':33/66, 'y':46/46},
                'decor37MC':{'x':18/36, 'y':36/36},
                'decor56MC':{'x':40/81, 'y':32/33},
                'decor54MC':{'x':40/81, 'y':32/33},
                'decor55MC':{'x':40/81, 'y':32/33},
                'decor33MC':{'x':16/32, 'y':32/36},
                'decor28MC':{'x':16/32, 'y':32/36},
                'decor35MC':{'x':16/32, 'y':32/36},
                'decor30MC':{'x':16/32, 'y':32/36},
                'decor29MC':{'x':16/32, 'y':32/36},
                'decor34MC':{'x':16/32, 'y':32/36},
                'decor43MC':{'x':-5.5, 'y':48/96},
                'decor42MC':{'x':-4.5, 'y':48/96},
                'decor40MC':{'x':48/96, 'y':1/10},
                'decor39MC':{'x':48/96, 'y':1/10},
                'decor59MC':{'x':0, 'y':0},
                /*'decor112MC':{'x':16/841, 'y':6/130},
                'decor113MC':{'x':59/151, 'y':12/155},
                'decor92MC':{'x':0/148, 'y':3/233},
                'decor91MC':{'x':0, 'y':0},
                'decor77MC':{'x':29/144, 'y':3/147},
                'decor82MC':{'x':48/96, 'y':-15/96},
                'decor4MC':{'x':0, 'y':0},
                'decor100MC':{'x':17/135, 'y':250/329},
                'decor109MC':{'x':74/148, 'y':47/80},
                'decor101MC':{'x':87/178, 'y':-21/91},
                'decor115MC':{'x':0, 'y':0},
                'decor108MC':{'x':75/150, 'y':47/80},
                'decor84MC':{'x':51/102, 'y':-25/22},
                'decor83MC':{'x':50/102, 'y':-15/23},
                'decor79MC':{'x':31/96, 'y':0/111},
                'decor81MC':{'x':21/22, 'y':3/115},
                'decor78MC':{'x':31/160, 'y':3/117},
                'decor64MC':{'x':0, 'y':0},
                'decor63MC':{'x':0, 'y':0},
                'decor65MC':{'x':0, 'y':0},
                'decor62MC':{'x':0, 'y':0},
                'decor73MC':{'x':0, 'y':0},
                'decor10MC':{'x':0.5, 'y':1},
                'decor26MC':{'x':0.5, 'y':1},
                'decor86MC':{'x':0, 'y':0},
                'decor98MC':{'x':62/126, 'y':39/68},
                'decor99MC':{'x':82/126, 'y':39/68},
                'decor97MC':{'x':38/57, 'y':0.6},
                'decor95MC':{'x':54/111, 'y':35/112},
                'decor94MC':{'x':54/111, 'y':35/112},
                'decor93MC':{'x':54/111, 'y':35/112},
                'decor80MC':{'x':31/23, 'y':3/113},
                'decor76MC':{'x':51/147, 'y':3/146},
                'decor12MC':{'x':0/96, 'y':5/69},
                'decor69MC':{'x':25/307, 'y':0/135},
                'decor15MC':{'x':0, 'y':0},
                'decor16MC':{'x':0.12, 'y':0.77},
                'decor68MC':{'x':-5/58, 'y':1/79},
                'decor19MC':{'x':0, 'y':0},
                'decor13MC':{'x':0, 'y':0},
                'decor17MC':{'x':0, 'y':0},
                'decor18MC':{'x':0, 'y':0},
                'decor14MC':{'x':0, 'y':0},
                'decor20MC':{'x':0, 'y':0},
                'decor107MC':{'x':77/154, 'y':47/80},
                'decor106MC':{'x':80/160, 'y':47/82},
                'decor105MC':{'x':74/148, 'y':47/81},
                'decor104MC':{'x':71/142, 'y':47/81},
                'decor103MC':{'x':75/150, 'y':47/81},
                'decor102MC':{'x':75/150, 'y':47/81},
                'decor71MC':{'x':23/78, 'y':28/76},
                'decor70MC':{'x':23/78, 'y':15/76},
                'decor72MC':{'x':0, 'y':0},
                'decor67MC':{'x':0, 'y':0},
                'decor74MC':{'x':8/56, 'y':1/37},
                'decor75MC':{'x':8/56, 'y':1/37},
                'decor110MC':{'x':22/47, 'y':0/21},
                'decor31MC':{'x':22/45, 'y':21/21},
                'decor37MC':{'x':0.5, 'y':1},
                'decor66MC':{'x':0, 'y':0},
                'decor96MC':{'x':45/57, 'y':1},
                'decor7MC':{'x':0, 'y':0},
                'decor36MC':{'x':0.5, 'y':1},
                'decor61MC':{'x':16/96, 'y':32/64},
                'decor59MC':{'x':0.5, 'y':1},
                'decor114MC':{'x':0, 'y':0},
                'decor6MC':{'x':0, 'y':0},
                'decor8MC':{'x':0, 'y':0},
                'decor111MC':{'x':0, 'y':0},
                'decor90MC':{'x':0, 'y':0},
                'decor89MC':{'x':0, 'y':0},
                'decor88MC':{'x':0, 'y':0},
                'decor87MC':{'x':0, 'y':0},*/
            };
            let animations:object = {
                'decor95MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor94MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor93MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor37MC':{'start': 0, 'end':82, 'autoplay':true},
                'decor36MC':{'start': 0, 'end':82, 'autoplay':true},
                'decor71MC':{'start': 0, 'end':29, 'autoplay':true},
                'decor70MC':{'start': 0, 'end':29, 'autoplay':true},
                'decor110MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor31MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor32MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor45MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor99MC':{'start': 0, 'end':73, 'autoplay':true},
                'decor98MC':{'start': 0, 'end':53, 'autoplay':true},
                'decor96MC':{'start': 0, 'end':59, 'autoplay':true},
                'decor97MC':{'start': 0, 'end':73, 'autoplay':true},
                'decor26MC':{'start': 0, 'end':89, 'autoplay':true},
                'decor10MC':{'start': 0, 'end':89, 'autoplay':true},
                'decor49MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor48MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor54MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor56MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor55MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor51MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor52MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor50MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor53MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor57MC':{'start': 0, 'end':88, 'autoplay':true},
                'decor41MC':{'start': 0, 'end':12, 'autoplay':true},
                'decor38MC':{'start': 0, 'end':12, 'autoplay':true},
                'decor1MC':{'start': 0, 'end':12, 'autoplay':true},
                'decor6MC':{'start': 0, 'end':12, 'autoplay':true},
                'decor7MC':{'start': 0, 'end':12, 'autoplay':true},
                'decor46MC':{'start': 0, 'end':11, 'autoplay':true},
                'decor47MC':{'start': 0, 'end':11, 'autoplay':true},
                'decor43MC':{'start': 0, 'end':25, 'autoplay':true},
                'decor42MC':{'start': 0, 'end':25, 'autoplay':true},
                'decor40MC':{'start': 0, 'end':25, 'autoplay':true},
                'decor39MC':{'start': 0, 'end':25, 'autoplay':true},
            };
            let bodySize:object = {
                'decor95MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor94MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor93MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor71MC':{x:12, y:-17, w:59, h:56},
                'decor70MC':{x:12, y:41, w:59, h:56},
                'decor110MC':{x:0, y:0, w:44, h:10},
                'decor31MC':{x:0, y:11, w:44, h:12},
                'decor32MC':{x:0, y:11, w:44, h:12},
                'decor45MC':{x:0, y:11, w:44, h:12},
                'decor107MC':{x:0, y:31, w:154, h:78},
                'decor109MC':{x:0, y:31, w:154, h:78},
                'decor104MC':{x:0, y:31, w:142, h:78},
                'decor105MC':{x:0, y:31, w:148, h:78},
                'decor106MC':{x:0, y:31, w:160, h:78},
                'decor103MC':{x:0, y:31, w:150, h:78},
                'decor102MC':{x:0, y:31, w:150, h:78},
                'decor108MC':{x:0, y:31, w:150, h:78},
                'decor99MC':{x:30, y:10, w:57, h:37},
                'decor97MC':{x:35, y:20, w:57, h:37},
                'decor98MC':{x:20, y:10, w:57, h:37},
                'decor12MC':{x:23, y:0, w:36, h:64},
                'decor15MC':{x:23, y:0, w:36, h:64},
                'decor16MC':{x:45, y:246, w:38, h:62},
                'decor17MC':{x:28, y:6, w:38, h:64},
                'decor18MC':{x:-10, y:22, w:73, h:38},
                'decor14MC':{x:-9, y:22, w:73, h:38},
                'decor13MC':{x:-4, y:22, w:50, h:38},
                'decor19MC':{x:-4, y:45, w:58, h:38},
                'decor100MC':{x:0, y:50, w:135, h:329},
                'decor47MC':{x:-234, y:-5, w:245, h:95},
                'decor46MC':{x:25, y:-5, w:245, h:95},
                'decor101MC':{x:1, y:10, w:178, h:78},
                'decor59MC':{x:0, y:0, w:23, h:63},
                'decor44MC':{x:0, y:0, w:98, h:97},
                'decor40MC':{x:0, y:0, w:32, h:5},
                'decor57MC':{x:0, y:0, w:95, h:49},
                'decor49MC':{x:0, y:0, w:84, h:33},
                'decor7MC':{x:0, y:0, w:186, h:72},
                'decor53MC':{x:0, y:0, w:81, h:35},
                'decor50MC':{x:0, y:0, w:81, h:33},
                'decor52MC':{x:0, y:0, w:81, h:36},
                'decor48MC':{x:0, y:0, w:81, h:33},
                'decor6MC':{x:0, y:0, w:112, h:74},
                'decor1MC':{x:0, y:0, w:93, h:72},
                'decor51MC':{x:0, y:0, w:81, h:37},
                'decor56MC':{x:0, y:0, w:81, h:33},
                'decor55MC':{x:0, y:0, w:81, h:35},
                'decor54MC':{x:0, y:0, w:81, h:33},
            };
            let mapLookingLeft:object = {
                'decor99MC':false,
                'decor98MC':false,
                'decor96MC':false,
                'decor97MC':false,
                'decor108MC':true,
                'decor105MC':true,
                'decor106MC':true,
                'decor102MC':true,
                'decor103MC':true
            };
            let decor;
            if (bodySize.hasOwnProperty(libId)) {
                decor = this.scene.physics.add.sprite(0, 0, 'decor-atlas', libId + '0000');
                decor.setCollideWorldBounds(false);
                decor.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                decor.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                if (bodySize[libId].hasOwnProperty('yFlipped')) {
                    decor.body.offset['-y-'] = bodySize[libId]['y'];
                    decor.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                } else {
                    decor.setImmovable(true);
                }
                decor.body["setAllowGravity"](false);
            } else {
                let frame:string = libId + '0000';
                decor = this.scene.add.sprite(0, 0, 'decor-atlas', frame);
                if (!(decor as Phaser.GameObjects.Sprite).texture.frames.hasOwnProperty(frame)) {
                    decor.visible = false;
                }
            }
            if (mapLookingLeft.hasOwnProperty(libId)) {
                decor['lookingLeft'] = mapLookingLeft[libId];
            }
            if (mapOrigins[libId]) {
                decor.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            } else {
                decor.setOrigin(0.5, 0.5);
            }
            if (animations[libId]) {
                let anim:string = libId + "_" + "playingAnimName";
                decor["playingAnimName"] = anim;
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(decor.texture.key, {
                            start: animations[libId]['start'], end: animations[libId]['end'], zeroPad: 4,
                            prefix: libId, suffix: ''
                        }),
                        frameRate: 60,
                        repeat: animations[libId]['autoplay'] ? -1 : 0
                    });
                }
                if (animations[libId]['autoplay']) {
                    decor.play(decor["playingAnimName"]);
                }
            }

            return decor;
        }
        private createEnemySprite(libId:string):Phaser.GameObjects.Sprite {
            let mapOrigins:object = {
                'enemy1MC':{'x':45/91, 'y':28/47},
                'enemy2MC':{'x':35/68, 'y':0.1},
                'hazard1MC':{'x':50/100, 'y':95/95},
                'hazard2MC':{'x':50/100, 'y':63/63}
            };
            let animations:object = {
                'enemy1MC': {
                    'move':{'start': 0, 'end':35, 'repeat':-1},
                    'attack':{'start': 0, 'end':35, 'repeat':-1},
                    'die':{'start': 36, 'end':91, 'repeat':0}
                },
                'enemy2MC': {
                    'idle':{'start': 0, 'end':0, 'repeat':0},
                    'drop':{'start': 0, 'end':0, 'repeat':0},
                    'pull':{'start': 1, 'end':1, 'repeat':0},
                    'attack':{'start': 1, 'end':1, 'repeat':0}
                }
            };
            let bodySize:object = {
                'enemy1MC':{x:10, y:10, yFlipped:0, w:70, h:20},
                'enemy2MC':{x:0, y:10, yFlipped:0, w:70, h:30},
                'hazard1MC':{x:0, y:0, w:101, h:50},
                'hazard2MC':{x:0, y:0, w:101, h:80}
            };

            let enemy:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
            enemy.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            enemy.setCollideWorldBounds(false);
            enemy.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
            enemy.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
            if (bodySize[libId].hasOwnProperty('yFlipped')) {
                enemy.body.offset['-y-'] = bodySize[libId]['y'];
                enemy.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
            } else {
                enemy.setImmovable(true);
            }
            enemy.body["setAllowGravity"](false);

            if (animations[libId]) {
                for (let k in animations[libId]) {
                    let anim:string = libId + "_" + k;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(enemy.texture.key, {
                                start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId][k]['repeat']
                        });
                    }
                }
            }

            if (libId == "hazard1MC" || libId == "hazard2MC") {
                let waves:Phaser.GameObjects.Container = this.scene.add.container(0, 0);

                let n = 6;
                for (let i:number = 0; i < n; i++) {
                    let miniwave:Phaser.GameObjects.Sprite = this.scene.add.sprite(enemy.width / 2 + (16 * (i - (n%2==0?(n/2-0.5):(n-1)/2) - 2)), -enemy.height + 5, 'objects-atlas', 'miniwave0000');
                    miniwave.setOrigin(0.5, 1);
                    miniwave.x -= miniwave.width;
                    if (i%2==0) miniwave.scaleX = -1;

                    let miniwave_anim:string = 'miniwave-anim';
                    if (!this.scene.anims.exists(miniwave_anim)) {
                        this.scene.anims.create({
                            key: miniwave_anim,
                            frames: this.scene.anims.generateFrameNames('objects-atlas', {
                                start: 0, end: 34, zeroPad: 4,
                                prefix: 'miniwave', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    miniwave.play(miniwave_anim);

                    waves.add(miniwave);
                }

                enemy["-attachedSprite-"] = waves;
            }

            return enemy;
        }

        private createOtherSprite(libId:string):Phaser.GameObjects.Sprite {
            let mapOrigins:object = {
                'bblock1MC':{'x':0.5, 'y':1}
            };

            if (!mapOrigins.hasOwnProperty(libId)) return null;

            let bodySize:object = {
                'bblock1MC':{x:0, y:32/2-4, w:32, h:32}
            };
            let animations:object = {
                'bblock1MC':{
                    'mask':{'start': 7, 'end':7, 'repeat':0},
                    'masked':{'start': 7, 'end':7, 'repeat':0},
                    'wobble':{'start': 55, 'end':72, 'repeat':0},
                    'question-wobble':{'start': 74, 'end':91, 'repeat':0},
                    'break':{'start': 93, 'end':98, 'repeat':0},
                    'hidden':{'start': 100, 'end':107, 'repeat':0},
                    'makeSolid':{'start': 108, 'end':124, 'repeat':0},
                    'maskToSolid':{'start': 125, 'end':141, 'repeat':0},
                    'hiddenToSolid':{'start': 143, 'end':158, 'repeat':0},
                    'solid':{'start': 159, 'end':159, 'repeat':0},
                    'question':{'start': 167, 'end':174, 'repeat':0}
                }
            };

            let sprite:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
            sprite.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            sprite.setCollideWorldBounds(false);
            sprite.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
            sprite.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
            sprite.setImmovable(true);
            sprite.body["setAllowGravity"](false);

            for (let k in animations[libId]) {
                let anim:string = libId + "_" + k;
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(sprite.texture.key, {
                            start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                            prefix: libId, suffix: ''
                        }),
                        frameRate: 60,
                        repeat: animations[libId][k]['repeat']
                    });
                }
            }

            return sprite;
        }

        public createSprite(spriteInfo
                                    /*
                                    spriteInfo[0] = sprite id
                                    spriteInfo[1] = x
                                    spriteInfo[2] = y
                                    spriteInfo[3] = libId
                                    spriteInfo[4] = options
                                    */
                            ):Phaser.GameObjects.Sprite | Phaser.GameObjects.Container {
            let libId:string = spriteInfo[3];

            if (libId == "enemy4MC") libId = "enemy4MC" + "_kid" + (Math.ceil(Math.random()*3));

            let sprite_mc:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container = this.createConstructedObject(libId);
            if (!sprite_mc) {
                if (spriteInfo[3].indexOf("decor") == 0) {
                    sprite_mc = this.createDecorSprite(libId);
                } else if (spriteInfo[3].indexOf("enemy") == 0 || spriteInfo[3].indexOf("hazard") == 0) {
                    sprite_mc = this.createEnemySprite(libId);
                } else {
                    sprite_mc = this.createOtherSprite(libId);
                    if (!sprite_mc) {
                        sprite_mc = this.scene.add.sprite(0, 0, 'objects-atlas', libId + '0000')
                    }
                }
            }
            sprite_mc.setPosition(Number(spriteInfo[1]), Number(spriteInfo[2]));
            sprite_mc["defPosition"] = {x:Number(spriteInfo[1]), y:Number(spriteInfo[2])};

            sprite_mc["libId"] = libId;

            let spriteId = sprite_mc["spriteId"] = spriteInfo[0];

            // extract options
            let options:string[] = spriteInfo[4].split('_');

            let spriteType:string = sprite_mc["spriteType"] = options[0];

            if (spriteType == 'E') {
                // enemy
                // define enemy hits required
                sprite_mc["hitsToKill"] = Math.ceil(Number(options[1]));
                //moving range
                var movingRange = parseFloat(options[2]);
                if (!isNaN(movingRange)) {
                    sprite_mc["movingRange"] = movingRange;
                }
                // pixel range
                sprite_mc["enemyType"] = options[3];
                //sprite_mc.dx = sprite_mc.xSpeed;
                sprite_mc["dy"] = 0;
                sprite_mc["dead"] = false;
            } else if (spriteType == 'H') {
                // hazard
                // define hazard strength
                sprite_mc["strength"] = options[1];
            } else if (spriteType=='C') {
                // chick / collectable
                // orientate?
                if (Math.random()>0.5) sprite_mc.scaleX = -1;
                sprite_mc["points"] = Number(options[1]);
                // flap at random:
                // sprite_mc.gotoAndStop(Math.ceil(Math.random()*15));
            } else if (spriteType=='D') {
                // decor
                sprite_mc["decorType"] = options[1];
                sprite_mc["speech"] = options[2];
                if (sprite_mc["decorType"]=='protestor' && sprite_mc["speech"]) {
                    sprite_mc["speaking"] = false;
                    sprite_mc["dy"] = 0;
                } else if ((sprite_mc["decorType"]=='pipeDown' || sprite_mc["decorType"]=='pipeSide' || sprite_mc["decorType"]=='pipeUp') && sprite_mc["speech"]) {
                    // rename correctly:
                    sprite_mc["pipeRoute"] = sprite_mc["speech"];
                } else if (sprite_mc["decorType"]=='bounce' || sprite_mc["decorType"]=='uberBounce') {
                } else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0,3)=='fan') {
                    if (sprite_mc["decorType"]=='fanUp') {
                        sprite_mc["fanDir"] = (sprite_mc["decorType"]=='fanUp') ? -1 : 1;
                    } else {
                        sprite_mc["fanDir"] = (sprite_mc["decorType"]=='fanLeft') ? -1 : 1;
                    }
                } else if (sprite_mc["decorType"]=='recovery') {
                    // recovery point
                    sprite_mc['-active-'] = false;
                } else if (sprite_mc["decorType"]=='switch') {
                    // flip switch
                    sprite_mc["switchType"] = options[3];
                }
                if (sprite_mc["decorType"]=='above') {
                    // send to front
                    // water object
                    if (sprite_mc["hitSpace_mc"]) {
                    }
                }
            } else if (spriteType == 'B') {
                // B (Blocks): [hitsToDestroy]-[playLabel]-[points/value]
                sprite_mc["hitsLeft"] = Number(options[1]);
                sprite_mc["playLabel"] = options[2];
                sprite_mc["points"] = Number(options[3]);
                sprite_mc["displayType"] = options[4];

                // value block?
                if (sprite_mc["playLabel"]) {
                    if (!sprite_mc["displayType"]) sprite_mc["displayType"] = 'question';
                    this.gotoAndPlay(sprite_mc as Phaser.GameObjects.Sprite, sprite_mc["displayType"]);
                }
            }

            if (sprite_mc["libId"] == "decor3MC") {
                let zzz_anim:string = 'zzz-anim';
                if (!this.scene.anims.exists(zzz_anim)) {
                    this.scene.anims.create({
                        key: zzz_anim,
                        frames: this.scene.anims.generateFrameNames('decor-atlas', {
                            start: 0, end: 124, zeroPad: 4,
                            prefix: 'zzz', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                sprite_mc["-attachedSprite-"] = [];
                for (let i = 0; i < 4; i++) {
                    let zzz = this.scene.add.sprite(0, 0, 'decor-atlas', 'zzz0000');
                    zzz.setOrigin(-0.3, 1.3);
                    setTimeout(()=>{
                        zzz.play(zzz_anim);
                    }, i * 250);
                    sprite_mc["-attachedSprite-"].push(zzz);
                }
                sprite_mc["-attachedSprite-layer-"] = "above";
            }

            if (sprite_mc["libId"] == "decor4MC") {
                let decor4MC_dot = this.scene.add.sprite(0, 0, 'decor-atlas', 'decor4MC_dot0000');
                decor4MC_dot.setOrigin(1.1, 1);
                let decor4MC_dot_anim:string = 'decor4MC_dot-anim';
                if (!this.scene.anims.exists(decor4MC_dot_anim)) {
                    this.scene.anims.create({
                        key: decor4MC_dot_anim,
                        frames: this.scene.anims.generateFrameNames('decor-atlas', {
                            start: 0, end: 126, zeroPad: 4,
                            prefix: 'decor4MC_dot', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                decor4MC_dot.play(decor4MC_dot_anim);
                sprite_mc["-attachedSprite-"] = decor4MC_dot;
                sprite_mc["-attachedSprite-layer-"] = "above";

            }

            return sprite_mc;
        }

        public createConstructedObject(libId:string):Phaser.GameObjects.Sprite | Phaser.GameObjects.Container {
            let object:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container = null;
            if (libId == "boss2MC") {
                object = new nscs.character.Boss(this.scene);
            } else if (libId == "flagPoleMC") {
                object = this.scene.add.container(0, 0);
                let flagPoleMC = this.scene.physics.add.sprite(0, 0, 'objects-atlas', 'flagPoleMC0000');
                flagPoleMC.setOrigin(0.5, 1);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).setCollideWorldBounds(false);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).body.setSize(9, 181);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).setImmovable(true);
                flagPoleMC.body["setAllowGravity"](false);
                object.add(flagPoleMC);
                object["flagPoleMC"] = flagPoleMC;

                let flag_kfc_MC = new Phaser.GameObjects.Image(this.scene,0, -185, 'objects-atlas','flag_kfc_MC0000');
                flag_kfc_MC.setOrigin(1, 0);
                (object as Phaser.GameObjects.Container).add(flag_kfc_MC);
                object["flag_kfc_MC"] = flag_kfc_MC;
            } else if (libId == "tinyChickMC") {
                object = this.scene.physics.add.sprite(0, 0, 'objects-atlas');
                object.setOrigin(12/24, 25/24);
                (object as Phaser.Physics.Arcade.Sprite).setCollideWorldBounds(false);
                (object as Phaser.Physics.Arcade.Sprite).body.setSize(24, 24);
                (object as Phaser.Physics.Arcade.Sprite).setImmovable(true);
                object.body["setAllowGravity"](false);

                let chick_mc_anim:string = 'tinyChickMC-anim';
                if (!this.scene.anims.exists(chick_mc_anim)) {
                    this.scene.anims.create({
                        key: chick_mc_anim,
                        frames: this.scene.anims.generateFrameNames('objects-atlas', {
                            start: 0, end: 15, zeroPad: 4,
                            prefix: 'tinyChickMC', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                object.play(chick_mc_anim);
            }
            return object;
        }

        public playAnimation(object:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container, animName:string = null):void {
            if (object["libId"] == "flagPoleMC") {
                let fn = (d)=>{
                    nscs.util.Functions.delayedCall(d, ()=>{
                        let flag_peta_MC = new Phaser.GameObjects.Image(this.scene,0, 0, 'objects-atlas','flag_peta_MC0000');
                        flag_peta_MC.setOrigin(0, 0);
                        flag_peta_MC.scaleX = 1;
                        flag_peta_MC.scaleY = 0;
                        this.scene.tweens.add({
                            targets: flag_peta_MC,
                            duration: 500,
                            y:-185,
                            scaleY:1,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        (object as Phaser.GameObjects.Container).add(flag_peta_MC);
                    });
                };

                if (animName == "normal-flag-reached") {
                    this.scene.tweens.add({
                        targets: object["flagPoleMC"],
                        duration: 500,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    this.scene.tweens.add({
                        targets: object["flag_kfc_MC"],
                        duration: 500,
                        y:0,
                        scaleY:0,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: ()=>{if(object["flag_kfc_MC"].parentContainer)object["flag_kfc_MC"].parentContainer.remove(object["flag_kfc_MC"]);}
                    });

                    fn(500);
                } else if (animName == "boss-flag-reached") {
                    object["flagPoleMC"].alpha = 0;
                    this.scene.tweens.add({
                        targets: object["flagPoleMC"],
                        duration: 500,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -185);
                    this.scene.tweens.add({
                        targets: flag_kfc_MC,
                        duration: 500,
                        y:0,
                        scaleY:0,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: ()=>{if(flag_kfc_MC.parentContainer)flag_kfc_MC.parentContainer.remove(flag_kfc_MC);}
                    });

                    fn(1000);
                } else if (animName == "boss-flag-appear") {
                    object.y = object.y - 250;
                    object.setScale(1, 0.5);
                    object.alpha = 0;
                    this.scene.tweens.add({
                        targets: object,
                        duration: 500,
                        scaleY:1,
                        y:object.y + 250,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -50);
                    flag_kfc_MC.scaleY = 0;
                    this.scene.tweens.add({
                        targets: flag_kfc_MC,
                        duration: 500,
                        y:-185,
                        scaleY:1,
                        ease: Phaser.Math.Easing.Sine.Out
                    });
                    (object as Phaser.GameObjects.Container).add(flag_kfc_MC);
                }
            } else if (object["playingAnimName"]) {
                (object as Phaser.GameObjects.Sprite).play(object["playingAnimName"]);
            }
        }

        public gotoAndPlay(sprite:Phaser.GameObjects.Sprite, label:string):void {
            let animName:string = sprite["libId"] + "_" + label;
            sprite['_animationComplete_'] = false;
            sprite['_animationToComplete_'] = animName;
            if (!sprite["_animationComplete_listener_"]) {
                sprite["_animationComplete_listener_"] = true;
                sprite.on('animationcomplete', ()=>{
                    if (sprite.anims.getCurrentKey() == sprite['_animationToComplete_']) {
                        sprite['_animationComplete_'] = true;
                    }
                });
            }

            sprite.anims.stop();
            sprite.play(animName);
        }

        public isAnimationComplete(sprite):boolean {
            return !sprite.hasOwnProperty('_animationComplete_') || sprite['_animationComplete_'];
        }

        public createTypicalButton(x:number, y:number, key:string):Phaser.GameObjects.Sprite {
            let btn:Phaser.GameObjects.Sprite = this.scene.add.sprite(x, y, 'ui-atlas', key + "0000");
            btn.setInteractive({ cursor: 'pointer' });
            btn.on('pointerout', () => {
                btn.setFrame(key+'0000');
            });
            btn.on('pointerover', () => {
                btn.setFrame(key+'0001');
            });
            btn.on('pointerdown', () => {
                btn.setFrame(key+'0002');
            });
            return btn;
        }
    }
}
